import { Outlet, useLocation } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";

import "./Board.scss";

const Board: React.FC = () => {
  const location = useLocation();
  const isChatOpen = location.pathname.startsWith("/messages/") && location.pathname !== "/messages";

  return (
    <>
      {!isChatOpen && <Header />}
      <div className="board-outlet" id="board-outlet">
        <Outlet />
      </div>
      {!isChatOpen && <Footer />}
    </>
  );
};

export default Board;
